// extracted by mini-css-extract-plugin
module.exports =  {"zoom-buttons":"da51a739f7--zoom-buttons--jFxom","zoom-plus":"da51a739f7--zoom-plus--ESIHl","zoom-minus":"da51a739f7--zoom-minus--KafK2","icon":"da51a739f7--icon--RUpqd"};